import React from 'react';
import { hesitations } from '../data/content';
import { HeartMark } from './decor/HeartMark';
const offsets = ['sm:ml-0', 'sm:ml-16', 'sm:ml-6'];
export function Problem() {
  return <section aria-labelledby="problem-title" className="bg-cream" data-id="element-217" data-mp="2bfzkm3qh6xxt">
      <div className="mx-auto grid max-w-content items-center gap-14 px-5 py-20 sm:px-8 lg:grid-cols-2 lg:py-28" data-id="element-218" data-mp="2bhtxcurlfjqt">
        <div data-id="element-219" data-mp="2ggn8igjeqynt">
          <h2 id="problem-title" className="text-balance font-display text-[38px] leading-[1.05] text-navy sm:text-5xl" data-id="element-220" data-mp="21q6912qc2itk">
            Sharing the Gospel shouldn’t depend on finding the perfect words.
          </h2>
          <div className="mt-6 space-y-4 text-lg leading-relaxed text-ink-soft" data-id="element-221" data-mp="1sq12svwvlqgz">
            <p data-id="element-222" data-mp="1wqjxcxq5lamv">
              You want to encourage people, talk about Jesus, share Scripture, or invite someone to church. But in the moment, it’s easy to
              hesitate — not sure what to say, how to begin, or what fits.
            </p>
            <p className="font-bold text-navy" data-id="element-223" data-mp="1nplr08s8sr14">
              The Gospel Sharing Mega Bundle gives you something simple and practical to reach for.
            </p>
          </div>
        </div>

        <div className="space-y-4" aria-label="Common hesitations" data-id="element-224" data-mp="oa2dz9l91uky">
          {hesitations.map((h, i) => <p key={h} className={`relative w-fit rounded-2xl rounded-bl-sm bg-white px-6 py-4 font-display text-2xl text-ink-soft shadow-card ring-1 ring-cream-line ${offsets[i]}`} data-id="element-225" data-mp="12a3fmr9c961h" data-mpi={i}>
              “{h}”
            </p>)}
          <div className="ml-auto flex w-fit max-w-sm items-start gap-3 rounded-2xl rounded-br-sm bg-navy px-6 py-5 text-white shadow-card" data-id="element-226" data-mp="5l5kh7xof63s">
            <HeartMark className="mt-1 h-5 w-5 shrink-0 text-coral" data-id="element-227" data-mp="jdu2c669gjij" />
            <p className="text-lg font-semibold leading-snug" data-id="element-228" data-mp="ek9207h73dg6">A ready Gospel message in your hand — for whatever moment comes.</p>
          </div>
        </div>
      </div>
    </section>;
}